import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
	title: string;
	loading?: boolean;
	showLoadingText?: boolean;
	titleClassName?: string;
} & React.ComponentProps<'button'>

const defaultProps = {
	loading: false,
	showLoadingText: false,
	titleClassName: ''
}

const PrimaryButton: FC<Props> = (props) => {
	const { title, loading, className, showLoadingText, titleClassName, ...rest } = props;
	const { t } = useTranslation();

	return (
		<button
			disabled={loading}
			{...rest}
			className={`btn btn-lg btn-primary radius-6 button-height-42px ${className}`}
		>
			{
				loading
					? <span className='indicator-progress' style={{ display: 'block' }}>
						{
							showLoadingText ? t('please_wait') : ''
						}
						<span className='spinner-border spinner-border-sm align-middle ms-2'></span>
					</span>
					: <span className={`indicator-label fs-135px ${titleClassName}`}>{t(title)}</span>
			}
		</button>
	)
};

PrimaryButton.defaultProps = defaultProps;

export default PrimaryButton;
